/**
 * Created by Ning Jiang on 6/21/2017.
 */

export class WixxWinPresentationEvent {
    public static readonly BIG_WIN_PRESENTATIONS_STOPPED:string = "wixxWinPresentationEvent_bigWinPresentationsStopped";
}